import { useGetLeaseBalanceQuery } from '@/store/api';
import type { BalanceItem } from '@/types/residents/lease';

/**
 * Fetches the current balance for a lease using the dedicated balance endpoint.
 * Works for all PMS types — the backend routes via PMSAdapterFactory.
 * Aligned with the web app's getTenantBalance / getResidentBalance pattern.
 */
export const usePaymentBalance = (leaseId: number | string, options?: { skip?: boolean }) => {
  const leaseIdNum = typeof leaseId === 'string' ? Number(leaseId) : leaseId;

  const {
    data: balanceData,
    isLoading,
    error,
    refetch,
  } = useGetLeaseBalanceQuery(leaseIdNum, {
    skip: options?.skip || !leaseIdNum,
  });

  const balanceDue = Number(balanceData?.balanceDue || 0);
  const accountCredit = Number(balanceData?.accountCredit || 0);
  const balanceItems: BalanceItem[] | undefined = balanceData?.balanceItems;

  return {
    balanceDue,
    accountCredit,
    balanceItems,
    isLoading,
    error,
    refetch,
    refreshBalance: refetch,
  };
};